<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Customer History</h2>
        </div>  

            <div class="card">
                <div class="card-title">
                    <h3 >Customer Details</h3>
                    </div>
                    <div class="card-body mt-2">
                        <span><strong>Name:</strong> {{Customerdetails.name}}</span><br>
                        <span><strong>Gst:</strong> {{Customerdetails.gst}}</span><br>
                        <span><strong>Cell:</strong> {{Customerdetails.cell}}</span><br>
                        <span><strong>Balance:</strong> {{Customerdetails.balance}}</span><br>
                        <span><strong>Address:</strong> {{Customerdetails.address}}</span>
                        </div>
                    
            </div>
     
                 <div class="card">
                       <h3 class="card-title">Order Details</h3>
                   </div>

        <div class="card p-2">
            <div class="flex flex-wrap items-end gap-4">
                <!-- From Date -->
                <div>
                    <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                    <input
                        type="date"
                        id="startDate"
                        v-model="filter.startDate"
                        class="p-2 border border-gray-300 rounded w-full"
                    />
                </div>

                <!-- To Date -->
                <div>
                    <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                    <input
                        type="date"
                        id="endDate"
                        v-model="filter.endDate"
                        class="p-2 border border-gray-300 rounded w-full"
                    />
                </div>


                <!-- Filter Button -->
                <div class="self-end mt-6">
                    <button
                        type="submit"
                        @click="getFilterBasics(1)"
                        class="btn btn-primary-solid px-5 py-2 rounded cursor-pointer"
                    >
                        Filter
                    </button>
                </div>
            </div>
        </div>



        <div class="grid grid-cols-12">

            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                  
                    <div class="p-6 space-y-4 overflow-x-auto">
                        <table id="datatable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Bill No</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Customer Name</th>
                                    <th class="bg-[#B2E8D9]">Paid</th>
                                    <th class="bg-[#B2E8D9]">Total</th>
                                    <th class="bg-[#B2E8D9]">Discount</th>
                                    <th class="bg-[#B2E8D9]">Delivery</th>
                                    <th class="bg-[#B2E8D9]">Remark</th>
                                    <th class="bg-[#B2E8D9]">View</th>
                                  
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in custorders" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.entry_date}}</td>
                                    <td >{{item.cust_name}}</td>
                                    <td class="text-info">{{item.paid}}</td>
                                    <td class="text-danger">{{item.total}}</td>
                                    <td>{{item.discount}}</td>
                                    <td>{{ item.delivery === '0000-00-00' ? '--' : item.delivery }}</td>
                                    <td>{{item.remark}}</td>
                                    <td> 

                                      <div class="flex space-x-2">
                                        
                                        <button class="btn-icon btn-primary-icon-light size-7" @click="show_status(item.id)" >
                                                                                    <i class="ri-eye-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                                                    </button>


                                                                                
                                     
                                             <button class="btn-icon btn-primary-icon-light size-7" @click="print_invoice(item.id)" >
                                                   <i class="ri-printer-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                                </button> 
                                                </div>
                                         
                                    </td> 
                                  
                                </tr>
                            </tbody>

                             <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr style="background:rgb(226 232 240 / 0.5)">

                                    <td colspan="3"></td>
                                     <td class="text-info">{{FinalDet.paid}}</td>
                                     <td class="text-danger">{{FinalDet.total}}</td>
                                     <td>{{FinalDet.discount}}</td>
                                  
                                  
                                </tr>
                            </tfoot>
                         
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->

        </div>




   

                   <div class="card">
                       <h3 class="card-title">Accounting Details</h3>
                          <button class="btn-icon btn-primary-icon-light size-7 mt-2"  @click="accountModal(Customerdetails.id)">
                                            <i class="ri-cash-line text-inherit text-[13px]"></i>
                                        </button>
                   </div>



   <div class="card p-2">
            <div class="flex flex-wrap items-end gap-4">
                <!-- From Date -->
                <div>
                    <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                    <input
                        type="date"
                        id="startDate"
                        v-model="filter.startDate"
                        class="p-2 border border-gray-300 rounded w-full"
                    />
                </div>

                <!-- To Date -->
                <div>
                    <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                    <input
                        type="date"
                        id="endDate"
                        v-model="filter.endDate"
                        class="p-2 border border-gray-300 rounded w-full"
                    />
                </div>


                <!-- Filter Button -->
                <div class="self-end mt-6">
                    <button
                        type="submit"
                        @click="getFilterBasics"
                        class="btn btn-primary-solid px-5 py-2 rounded cursor-pointer"
                    >
                        Filter
                    </button>
                </div>
            </div>
        </div>







<!-- table for cust Accounting -->
  <div class="grid grid-cols-12">

            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4 overflow-x-auto">
                        <table id="datatable2" class="datatable2">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Bill No</th>
                                    <th class="bg-[#B2E8D9]">Date</th>
                                    <th class="bg-[#B2E8D9]">Customer Name</th>
                                    <th class="bg-[#B2E8D9]">Total</th>
                                    <th class="bg-[#B2E8D9]">Discount</th>
                                    <th class="bg-[#B2E8D9]">Paid</th>
                                  
                                    <th class="bg-[#B2E8D9]">Total Payable</th>
                                    <th class="bg-[#B2E8D9]">Note</th>
                                  
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in custaccounting" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.entrydate}}</td>
                                    <td >{{item.cust_name}}</td>
                                    <td class="text-info">{{item.total}}</td>
                                    <td>{{item.discount}}</td>
                                    <td class="text-success">{{item.paid}}</td>
                                    <td class="text-danger">{{item.total_payable}}</td>
                                    <td>{{item.note}}</td>
                                  
                                </tr>
                            </tbody>

                            <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr style="background:rgb(226 232 240 / 0.5)">
                                     <td colspan="3"></td>
                                    <td class="text-info">{{Final.total}}</td>
                                    <td>{{Final.discount}}</td>
                                    <td class="text-success">{{Final.paid}}</td>
                                     <td class="text-danger">{{Final.payable}}</td>
                                  
                                  
                                </tr>
                            </tfoot>



                         
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->

        </div>
<!-- table for cust Accounting -->



    </div>

    <!-- End Main Content -->


   <!-- Modal -->
<div v-if="showModel" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-2xl shadow-lg w-full max-w-md mx-auto border-2 border-black">
    <div class="flex justify-between items-center p-4 border-b">
      <h2 class="text-lg font-semibold">Order Status</h2>
      <button @click="closeModel" class="text-gray-500 hover:text-gray-700 text-2xl leading-none">&times;</button>
    </div>
    <div class="p-2">
      <!-- <p class="text-gray-700">Modal body text goes here.</p> -->
     <div class="p-6 space-y-4">
  <div class="overflow-x-auto"  v-if="orderstatus.length > 0" >

    <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-xl">
      <thead class="bg-gray-100 dark:bg-gray-700">
        <tr>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">#</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Product Name</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Qty</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Delivery Date</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Tailor Assign</th>
          <th class="px-4 py-2 text-left text-sm font-semibold text-gray-700 dark:text-white">Status</th>
        </tr>
      </thead>
      <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700">
        <tr v-for="(item, index) in orderstatus" :key="item.id">
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ index + 1 }}</td>
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ item.stich_name }} ({{ item.prd_name }})</td>
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ item.pieceqty }} ({{ item.meterqty }})</td>
          <td class="px-4 py-2 text-gray-800 dark:text-white">{{ item.deliverydate === '0000-00-00' ? '--' : item.deliverydate }}</td>
          <td class="px-4 py-2 text-danger">{{ item.tailor_name || 'No Tailor' }}</td>
          <td class="px-4 py-2">
            <span :class="{
              'text-danger': item.markstatus == 0,
              'text-warning': item.markstatus == 1,
              'text-success': item.markstatus == 2
            }">
              {{ item.markstatus == 0 ? 'Pending' : item.markstatus == 1 ? 'Processing' : 'Complete' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <!-- Prism Code (optional / hidden block) -->
  <div class="p-6 hidden">
    <pre>
      <code class="language-markup">
        &lt;p&gt;Sorry we can't show the huge data&lt;/p&gt;
      </code>
    </pre>
  </div>
</div>

    </div>
    <!-- <div class="flex justify-end gap-2 p-4 border-t">
      <button @click="closeModel" class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300">
        Close
      </button>
      <button class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Save changes
      </button>
    </div> -->
  </div>
</div>






  <div id="accountModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
              
                <div class="p-4 md:p-5" >
                    <h6>Voucher For: {{sel_customer_name}}</h6>
                      <form>
                    <div class="mt-5" v-on:keyup.enter="nextFocus">
                        <div class="mt-5">
                            <label for="first_input" class="form-label">Date*</label>
                            <input type="date" v-model="account.entrydate" class="form-input" id="first_input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Paid Amount *</label>
                            <input type="number" v-model="account.paid" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Note *</label>
                            <input type="text" v-model="account.note" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        
                    </div>
                    </form>

                        <div class="flex justify-end mt-5">
                            <button @click="saveAccount" id="saveAccBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>





















</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'SaleList',
components: {

} ,
mounted(){


    if (this.$route.query.q) {
           this.getBasics(this.$route.query.q);
    }else{
       this.getBasics();
    }
},
data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     saleList:[],
     orderstatus:[],
     showModel:false,
     datatable:null,

     Customerdetails:[],
     custorders:[],
     custaccounting:[],
     Final:{total:0,paid:0,payable:0,discount:0},
     FinalDet:{total:0,paid:0,discount:0},
     showModel:false,
     account:{entrydate:this.todayDate(),paid:0,cust_id:0,note:''},

      filter:{
            startDate:this.getStartDate(),
            endDate:today,
            filterid:''
        },

   

     
 }
 },
methods:{
    

  getStartDate() {
      let startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      //startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },


                       
 async getBasics(id) {
       var self=this;
            self.filter.filterid=id;
         axios.post('getcustomerhistory',{id:id}).then(function (response) {
                self.destroyDatatble();
                 self.Customerdetails=response.data.customerdetails;
                  self.custorders=response.data.custorders;
                   self.custaccounting=response.data.custaccounting;
                 self.employees=response.data.userDetails;
                }).then(()=>{
                    self.refreshDatatble();
                    self.calculateTotal();
                    self.calculateTotal2();
                  
                    });
  },

     

 refreshDatatble() {
            self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false 
                            });

              self.datatable= $(".datatable2").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false 
                            });






         },
          destroyDatatble() {
                 if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }
                    if ($.fn.dataTable.isDataTable('.datatable2')) {
                        $('.datatable2').DataTable().destroy();
                    }
          },    



        calculateTotal(){
        
            var self=this;

        self.Final=  {total:0,paid:0,payable:0,discount:0};


            Array.from(self.custaccounting).forEach((row) => {
                    self.Final.total+=parseFloat(row.total);
                    self.Final.paid+=parseFloat(row.paid);
                    self.Final.discount+=parseFloat(row.discount);
                    self.Final.payable+=parseFloat(row.total)-parseFloat(row.discount);


            });
        },


   calculateTotal2(){
        
            var self=this;

        self.FinalDet=  {total:0,paid:0,discount:0};


            Array.from(self.custorders).forEach((row) => {
                    self.FinalDet.total+=parseFloat(row.total);
                    self.FinalDet.paid+=parseFloat(row.paid);
                    self.FinalDet.discount+=parseFloat(row.discount);
                


            });
        },




            show_status(id){
                    // alert("hello");
                    this.showModel=true;

                        var self=this;
                                axios.post('getorderstatus',{id:id}).then(function (response) {
                                        self.destroyDatatble();
                                    // self.saleList=response.data.saleList;
                                    // self.employees=response.data.userDetails;
                                        self.orderstatus=response.data.orderstatus;
                                        }).then(()=>{
                                            self.refreshDatatble();

                                            self.calculateTotal();
                                            });

                    },
                    closeModel() {
                this.showModel = false;
            },



 closeModal(){

    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
                      $("#accountModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },
     accountModal(id){
      
        if(!this.isAccount)
            $("#accountModal").removeClass('hidden');
        else
            $("#accountModal").addClass('hidden');
            
        this.account.cust_id=id;
     //   this.sel_customer_name=item.name;
    //    this.isAccount=!this.isAccount;
    },


 todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },
    saveAccount() {
                var self = this; 
                if(self.account.paid==0){
                    self.$swal("Please Enter Paid Amount");
                }else  if(self.account.cust_id==0){
                    self.$swal("Customer Not Found");
                }else{
                    axios.post('addAccountVoucherfrom', this.account)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.CustomerList=response.data.list;
                            self.employees=response.data.userDetails;
                             self.Customerdetails=response.data.customerdetails;
                            self.custorders=response.data.custorders;
                           self.custaccounting=response.data.custaccounting;
                               self.Customer={name:'',cell:'',address:'',gst:''};

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },


                     getFilterBasics(type) {
                      var self=this;
                       axios.post('getfiltercustomerhistory',{...self.filter,type: type}).then(function (response) {
                     
                        self.destroyDatatble();
                           self.Customerdetails=response.data.customerdetails;
                            self.custorders=response.data.custorders;
                            self.custaccounting=response.data.custaccounting;
                            self.employees=response.data.userDetails;
                        }).then(()=>{
                            self.refreshDatatble();
                             self.calculateTotal();
                            self.calculateTotal2();
                        
                            });


                      

                   },
                   print_invoice(id)
        {
             
               // window.open('/print?q='+id, '_blank');
                window.open('/thermalPrint?q='+id, '_blank'); 
        },


}
}
</script>
